// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/swiper-bundle.css';

// init Swiper:
const swiper = new Swiper('.swiper-container', {
  // configure Swiper to use modules
  modules: [Navigation, Pagination, Autoplay],
    direction: 'horizontal',
    loop: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    speed: 1000,

    // // If we need pagination
    // pagination: {
    //     el: '.swiper-pagination',
    //     clickable: true
    // },

    // // Navigation arrows
    navigation: {
        nextEl: '.swiper--next',
        prevEl: '.swiper--prev',
    },

    // // And if we need scrollbar
    // scrollbar: {
    //     el: '.swiper-scrollbar',
    // }
});
